import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import { AuthUser } from '@modules/AuthModule/lib/types';
import { UserE911AddressState } from './types';
import { proxy } from 'valtio';
import extractErrorMessage from '@lib/utils/extractErrorMessage';
import { AddressInput } from '@api/generated/graphql';
import updateUserE911Address from './updateUserE911Address';
import { ApolloError } from '@apollo/client';
import { convertAddressAndPopulateCountry } from './addressUtils';
import DiagnosticsModule from '@modules/DiagnosticsModule';

/**
 * Defines the global state for the user e911 address
 */
export const userE911AddressState = proxy<UserE911AddressState>({
  e911Address: undefined,
});

const setUserE911AddressState = (e911Address: AddressInput | null) => {
  if (e911Address) {
    userE911AddressState.e911Address = e911Address;
  }
};
export class E911AddressModule extends AppModule {
  override preload(): void {
    this.app.events.on('auth.signin', (user: AuthUser) => {
      if (user.e911Address)
        setUserE911AddressState(
          convertAddressAndPopulateCountry(user.e911Address),
        );
    });
  }

  public async setUserE911Address(userId: string, e911Address: AddressInput) {
    try {
      updateUserE911Address(userId, e911Address);
      setUserE911AddressState(e911Address);
    } catch (error) {
      if (error instanceof ApolloError) {
        DiagnosticsModule.reportUserError({
          message: error.message,
          priority: 'direct',
        });
        return;
      }
      throw new Error(extractErrorMessage(error));
    }
  }
}

export default new E911AddressModule(
  appManager.events,
  appManager.logger('E911Address'),
);
